import { useState, useEffect } from "react";
import {
  Container,
  Paper,
  CircularProgress,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  useMediaQuery,
  useTheme,
  Link,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  UpdateContractActive,
  UpdateContractVersion,
  FetchTemplateLibraryData,
  CopyHHTemplateLibrary,
  DeleteHHTemplateLibrary,
} from "../api/contractVersionService";
import toast from "react-hot-toast";
import ConfirmationDialog from "../confirm/confirmation";
import { ACTION, ROLE } from "../utils/commonConstant";
import { DataGrid } from "@mui/x-data-grid";
import "../App.css";

const TemplateLibrary = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const role = localStorage.getItem("Role");
  const [editData, setEditData] = useState({
    VersionName: "",
    HHApprovalStatus: "",
    InsurerApprovalStatus: "",
    COApprovalStatus: "",
    IsActive: false,
  });
  const { clientId } = useParams();
  const navigate = useNavigate();
  const approvalStatus = ["Pending", "Approved"];

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [rowToConfirm, setRowToConfirm] = useState(null);
  const [confirmHHDialogOpen, setConfirmHHDialogOpen] = useState(false);
  const [confirmIsActiveDialogOpen, setConfirmIActiveDialogOpen] =
    useState(false);
  const [confirmCOApprovalDialogOpen, setConfirmCOApprovalialogOpen] =
    useState(false);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });
  const [rows, setRows] = useState([]);
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 100,
      headerClassName: "bold-header",
    },
    {
      field: "Name",
      headerName: "Template Name",
      width: 500,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => (
        <Tooltip title="Please Click For Edit" arrow>
          <Link
            href={`/${clientId}/template/${ACTION.EDIT}/${params.row.Id}`}
            underline="hover"
            sx={{
              color: "text.primary",
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            {params.value}
          </Link>
        </Tooltip>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 500,
      sortable: false,
      align: "center",
      headerClassName: "bold-header",
      headerAlign: "center",
      renderCell: (params) => (
        <Box>
          <Tooltip title="Action/Copy" arrow>
            <IconButton onClick={(event) => handleMenuOpen(event, params.row)}>
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            {/* <MenuItem onClick={handleEdit}>Edit</MenuItem> */}
            <MenuItem onClick={handleCopyTemplate}>Duplicate</MenuItem>
            {role === ROLE.ADMIN && (
              <MenuItem onClick={handleDeleteTemplate}>Delete</MenuItem>
            )}
          </Menu>
        </Box>
      ),
    },
  ];
  const fetchData = async () => {
    try {
      const result = await FetchTemplateLibraryData();
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const addIdToData = (data) => {
    // Create a new array with 'id' field added to each object
    return data.map((item) => ({ ...item, id: item.Id }));
  };

  useEffect(() => {
    fetchData();
  }, [clientId]);

  useEffect(() => {
    const updatedRows = addIdToData(data);
    setRows(updatedRows);
  }, [data]);

  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography color="error">
          Error fetching data: {error.message}
        </Typography>
      </Container>
    );
  }

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    setEditData(selectedRow);
    setEditDialogOpen(true);
    handleMenuClose();
  };

  const handleActivateContract = async () => {
    console.log("Update Status:", rowToConfirm);
    const resp = await UpdateContractActive(rowToConfirm.Id);
    console.log("handleActivateContract :", resp);
    handleMenuClose();
    fetchData(); // Refresh data after update
    toast.success("Contract is activated successfully.");
    setConfirmIActiveDialogOpen(false);
  };

  const handleCopyTemplate = async () => {
    console.log("Update Status:", selectedRow);
    const resp = await CopyHHTemplateLibrary(selectedRow.Id);
    console.log("handleActivateContract :", resp);
    if (!resp) {
      toast.error("Error Occured during copying");
    }
    handleMenuClose();
    fetchData(); // Refresh data after update
    toast.success("Template is copied successfully.");
  };

  const handleDeleteTemplate = async () => {
    console.log("Update Status:", selectedRow);
    const resp = await DeleteHHTemplateLibrary(selectedRow.Id);
    console.log("handleActivateContract :", resp);
    if (!resp) {
      toast.error("Error Occured during copying");
    }
    handleMenuClose();
    fetchData();
    toast.success("Template delete successfully.");
  };

  const handleCreate = () => {
    navigate(`/${clientId}/template/${ACTION.CREATE}`);
  };
  const handleHome = () => {
    navigate(`/${clientId}`);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleAutocompleteChange = (event, newValue, fieldName) => {
    setEditData({ ...editData, [fieldName]: newValue });
  };

  const handleEditSave = async () => {
    try {
      console.log("Save Edit Data:", editData);
      const updatedContract = await UpdateContractVersion(
        editData.Id,
        editData
      );
      console.log("Save Edit:", updatedContract);
      fetchData(); // Refresh data after update
      // Optionally update state or handle success message
      toast.success("Updated successfully.");
    } catch (error) {
      // Handle error
    }
    setEditDialogOpen(false);
  };

  const confirmToggleHHApproval = async () => {
    const updatedStatus =
      rowToConfirm.HHApprovalStatus === "Approved" ? "Pending" : "Approved";
    const updatedData = {
      ...rowToConfirm,
      HHApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
      fetchData(); // Refresh data after update
      toast.success(`HH Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating HH Approval Status");
    }
    setConfirmHHDialogOpen(false);
    setRowToConfirm(null);
  };

  const confirmToggleCOApproval = async () => {
    const updatedStatus =
      rowToConfirm.COApprovalStatus === "Approved" ? "Pending" : "Approved";
    const updatedData = {
      ...rowToConfirm,
      COApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
      fetchData(); // Refresh data after update
      toast.success(`CO Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating HH Approval Status");
    }
    setConfirmCOApprovalialogOpen(false);
    setRowToConfirm(null);
  };
  const confirmToggleInsurerApproval = async () => {
    const updatedStatus =
      rowToConfirm.InsurerApprovalStatus === "Approved"
        ? "Pending"
        : "Approved";
    const updatedData = {
      ...rowToConfirm,
      InsurerApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData);
      fetchData(); // Refresh data after update
      toast.success(`Insurer Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating Insurer Approval Status");
    }
    setConfirmDialogOpen(false);
    setRowToConfirm(null);
  };
  const handleCloseConfirmationDialog = () => {
    setConfirmDialogOpen(false);
    setRowToConfirm(null);
  };

  return (
    <>
      <Box sx={{ padding: 2 }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ marginBottom: 2 }}
        >
          <Grid item xs={12} sm="auto" display="flex" justifyContent="center">
            <Link href={`/${clientId}`}>
              <img
                src="https://portal.hardhats.co.uk/img/Hardhats-Logo.png"
                alt="HardHats Logo"
                style={{ width: "80px", marginRight: "20px" }}
              />
            </Link>
          </Grid>
          <Grid item xs={12} sm="auto">
            <h2 style={{ textAlign: "center" }}>Template Library</h2>
          </Grid>
        </Grid>
        <Container>
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            mb={2}
            spacing={2}
          >
            {/* <Grid item>
              <Button variant="contained" color="primary" onClick={handleBack}>
                Back
              </Button>
            </Grid> */}
            <Grid item justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreate}
              >
                Create New
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleHome}>
                Home
              </Button>
            </Grid>
          </Grid>
          <Paper>
            <Box sx={{ height: 500, width: "100%" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10, 50, 100]}
                disableSelectionOnClick // Disable row selection
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                  setColumnVisibilityModel(newModel)
                }
              />
            </Box>
          </Paper>
        </Container>
      </Box>
      {/* model popup for edit */}
      <Dialog
        open={editDialogOpen}
        onClose={handleEditDialogClose}
        maxWidth="md"
        fullWidth={fullScreen}
      >
        <DialogTitle>Edit Contract Version</DialogTitle>
        <DialogContent sx={{ width: fullScreen ? "100%" : "600px" }}>
          <TextField
            margin="dense"
            name="VersionName"
            label="Version Name"
            type="text"
            fullWidth
            value={editData.VersionName}
            onChange={handleEditChange}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.HHApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "HHApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="HH Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.InsurerApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "InsurerApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="Insurer Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.COApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "COApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="CO Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleEditSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* confirmation for Insurer Approval  */}
      <ConfirmationDialog
        open={confirmDialogOpen}
        onClose={handleCloseConfirmationDialog}
        onConfirm={confirmToggleInsurerApproval}
        message={`Are you sure you want to toggle Insurer Approval Status for ${rowToConfirm ? rowToConfirm.VersionName : ""
          }?`}
      />
      {/* confirmation for HH Approval  */}
      <ConfirmationDialog
        open={confirmHHDialogOpen}
        onClose={() => setConfirmHHDialogOpen(false)}
        onConfirm={confirmToggleHHApproval}
        message={`Are you sure you want to toggle HH Approval Status for ${rowToConfirm?.VersionName}?`}
      />
      {/* confirmation for Activate contract  */}

      <ConfirmationDialog
        open={confirmIsActiveDialogOpen}
        onClose={() => setConfirmIActiveDialogOpen(false)}
        onConfirm={handleActivateContract}
        message={`Are you sure you want to Activate contract for ${rowToConfirm?.VersionName}?`}
      />

      {/* confirmation for   */}
      <ConfirmationDialog
        open={confirmCOApprovalDialogOpen}
        onClose={() => setConfirmCOApprovalialogOpen(false)}
        onConfirm={confirmToggleCOApproval}
        message={`Are you sure you want to toggle CO Approval Status for ${rowToConfirm?.VersionName}?`}
      />
    </>
  );
};

export default TemplateLibrary;
